import type { DropzoneLocale } from "@/locales/fr/dropzone";

export const dropzoneLocale: DropzoneLocale = {
  dropzone: {
    dropFilesHere: "Drop the files here ...",
    dragndrop: "Drag 'n' drop some files here, or click to select files",
    authorizedTypes: "Files: {types}",
    sizeMax: "Maximum size: {size}",
    errors: {
      fileInvalidType: "Invalid file type. Please select a valid file type.",
      fileTooLarge: "File too large. Please select a smaller file.",
      fileTooSmall: "File too small. Please select a larger file.",
      tooManyFiles: "Too many files selected. Please select a smaller number of files.",
      unknown: "An unknown error occurred while processing the file.",
    },
  },
};

export default dropzoneLocale;
